export default function Button({ onClick, type, children, className = "btn" }) {
  return (
    <button type={type} onClick={onClick} className={className}>
      {children}
    </button>
  );
}
